var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrowWhiteBig = function SvgRightArrowWhiteBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.558.437A1.5 1.5 0 1 0 .442 2.563L8.916 11 .442 19.437a1.5 1.5 0 0 0 2.116 2.126l9.542-9.5a1.5 1.5 0 0 0 0-2.126L2.558.437Z",
    fill: "#fff"
  })));
};
export default SvgRightArrowWhiteBig;